// extracted by mini-css-extract-plugin
module.exports = {"chartTitle":"HomeChart_chartTitle__472Qm"};